import { render, staticRenderFns } from "./BuyProductHistoryDetail.vue?vue&type=template&id=641187d8&scoped=true&"
import script from "./BuyProductHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./BuyProductHistoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./BuyProductHistoryDetail.vue?vue&type=style&index=0&id=641187d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641187d8",
  null
  
)

export default component.exports